<template>
  <transition :name="transition">
    <div
      v-show="show"
      class="notification"
      :class="{
        'notification--sticky': (notificationType ==='cart-updated' || notificationType === 'single-message'),
        'notification--general': notificationType === 'single-message',
        'notification--inline': (notificationType === 'callback-message' || notificationType === 'info-message'),
        'notification--info': (notificationType === 'callback-message' || notificationType === 'info-message'),

      }"
    >
      <template v-if="notificationType ==='cart-updated'">
        <span class="notification__cart-amount">{{ totalCartCount }}</span>
        <span class="notification__text">
          <span class="notification__text__highlight">{{ productsAdded }}</span>
          {{ productsAdded > 1 ? $modeoL10n.products_added : $modeoL10n.product_added }} {{ orderType ==='offer' ? $modeoL10n.to_offer : $modeoL10n.to_cart }}
        </span>

        <a
          v-if="!isCart"
          class="notification__link"
          :href="cartUrl"
        >{{ orderType ==='offer' ? $modeoL10n.go_to_offer : $modeoL10n.go_to_cart }}</a>
      </template>

      <template v-if="notificationType ==='single-message' || notificationType ==='info-message'">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="$sanitize(message)" />
      </template>

      <template v-if="notificationType === 'callback-message'">
        <div class="notification__container">
          {{ message }} <button
            class="btn btn--buy-small notification__button"
            @click="callback(); close();"
          >
            {{ callToAction }}
          </button>
        </div>
      </template>

      <button
        class="notification__close"
        @click="close()"
      >
        <span class="screen-reader-text">{{ $modeoL10n.close_notification }}</span>
      </button>
    </div>
  </transition>
</template>

<script>
    import { EventBus } from '../event-bus.js';
    import _ from 'lodash';

    export default {
        props: {
            cartUrl: {
                type: String,
                default: '',
            },
        },
        data : function () {
            return {
                productsAdded: 0,
                totalCartCount: 0,
                show: false,
                transition: 'fade',
                notificationType: 'single-message',
                message: "",
                timers: [],
                orderType: 'order',
                isCart: false,
                callback: function(){},
                callToAction: '',
            };
        },
        created: function () {

            EventBus.$on('notify', data => {
                this.transition = data.transition || 'fade';
                this.totalCartCount = data.totalCartCount;
                this.productsAdded = data.productsAdded;
                this.notificationType = data.notificationType;
                this.message = data.message;
                this.orderType = data.orderType || 'order';
                this.isCart = data.isCart || false;
                this.show = true;

                this.callback = data.callback || function(){};
                this.callToAction = data.callToAction || '';


                //Close notification automatically
                if (data.autoHide) {
                    this.timers[this.timers.length] = _.delay(function(notification) {
                        notification.show = false;
                    }, 3000, this);
                }
            });

        },
        methods: {
            close() {
                this.transition = 'fade-quick';
                this.show = false;
            },

            clearTimers() {
                for (var i=0; i < this.timers.length; i++) {
                    clearTimeout(this.timers[i]);
                }
                this.timers = [];
            },
        },
    }
</script>
